(() => {
  const root = document.documentElement;
  const rawThreshold = parseFloat(getComputedStyle(root).getPropertyValue('--scroll-reveal-threshold'));
  const threshold = Math.min(Math.max((isNaN(rawThreshold) ? 15 : rawThreshold) / 100, 0), 1);

  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    }
  }, { threshold, rootMargin: '0px 0px -5% 0px' });

  const observe = (scope = document) => {
    for (const el of scope.querySelectorAll('.scroll-reveal:not(.is-visible)')) {
      observer.observe(el);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => observe());
  } else {
    observe();
  }

  document.addEventListener('shopify:section:load', (event) => observe(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    if (event.target.classList?.contains('scroll-reveal')) {
      event.target.classList.add('is-visible');
    }
  });
})();
